import { render, staticRenderFns } from "./AppLevelBadge.vue?vue&type=template&id=5ee601b2&scoped=true"
import script from "./AppLevelBadge.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppLevelBadge.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./AppLevelBadge.vue?vue&type=style&index=0&id=5ee601b2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ee601b2",
  null
  
)

export default component.exports